/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import StarBorderRoundedIcon from '@mui/icons-material/StarBorderRounded';
import { Avatar, Rating } from '@mui/material';
import moment from 'moment';
import { Checkbox } from 'primereact/checkbox';
import { InputTextarea } from 'primereact/inputtextarea';
import { RadioButton } from 'primereact/radiobutton';
import { Button, Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { CustomTooltips } from '../../../../components';
import { IMAGE_URL, VENDOR_IMAGE_URL } from '../../../../constants/Config';
import {
  RATE_TRANSCRIPT_REQURIED,
  RATING_EXPLANATION_REQURIED,
  REWORK_NOTES_REQURIED,
} from '../../../../constants/ValidationMessageConstants';
import { capitalizeFirstLetter } from '../../../../utils/CapitalizeFirstLetterUtils';
import { truncateString } from '../../../../utils/TruncateStringUtils';
import { getUserInfo } from '../../../../utils/UserInfoUtils';
import { ProofreaderRoleEditorSubmitRequest, vendorNameListRequest } from '../actions';
import VendorSelectWithSearch from './VendorSelectWithSearch';
import { formatDateWithMilliseconds } from '../../../../constants/CurrentTimeFormet';

const ProofreaderSubmitModal = ({ editorDetailsData, vendorDetailData, submitShow, handleSubmitCloseModal }) => {
  const dispatch = useDispatch();
  const [rateExplanantionValue, setRateExplanantionValue] = useState('');
  const [reworkNote, setReworkNote] = useState('');
  const [valueRating, setValueRating] = useState(vendorDetailData?.Rate || 0);
  const [page, setPage] = useState('Vendor Rating');
  const [valueRework, setValueRework] = useState('');
  const [valueSendFile, setValueSendFile] = useState('');
  const [payVendor, setPayVendor] = useState('');
  const [blockVendor, setBlockVendor] = useState('');
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [payOriginalVendor, setPayOriginalVendor] = useState(false);
  const [hour, setHour] = useState(null);
  const [selectedNewVendor, setSelectedNewVendor] = useState(null);
  const userInfo = getUserInfo();
  const { id } = useParams();
  const [nextVendorRatingClick, setNextVendorRatingClick] = useState(false);
  const [nextReworkClick, setNextReworkClick] = useState(false);
  const [nextPayVendorClick, setNextPayClickVendor] = useState(false);

  useEffect(() => {
    if (editorDetailsData?.VendorId !== undefined) {
      dispatch(vendorNameListRequest(editorDetailsData?.VendorId));
    }
  }, [dispatch]);

  const closeModal = () => {
    setRateExplanantionValue('');
    setBlockVendor('');
    setValueRating(0);
    setReworkNote('');
    setPage('Vendor Rating');
    setValueRework('');
    setValueSendFile('');
    setPayVendor('');
    setSelectedVendor(null);
    setPayOriginalVendor(false);
    setHour(null);
    handleSubmitCloseModal();
    setNextVendorRatingClick(false);
    setNextReworkClick(false);
    setNextPayClickVendor(false);
  };

  const handleConfirm = () => {
    if (id) {
      let params = {
        vendorId: selectedVendor !== null ? selectedVendor : editorDetailsData?.VendorId,
        originalVendorId: editorDetailsData?.VendorId,
        userId: userInfo?.UserId,
        audioFileId: id,
        rating: valueRating,
        explanation: rateExplanantionValue,
        isBlockVendor: blockVendor === 'yes' ? true : false,
        isRework: valueRework === 'yes' ? true : false,
        isOriginalVendor: valueSendFile === 'NewVendor' ? false : true,
        isPayOriginal: payOriginalVendor,
        isVendorRejectPay: payVendor !== 'yes' || vendorDetailData?.vendorType === '1' ? true : false,
        reworkHours: parseInt(hour, 10),
        reworkNote: reworkNote,
        vendorRate:
          valueSendFile === 'NewVendor' && payOriginalVendor === false && valueRework === 'yes' && blockVendor !== 'yes'
            ? 0
            : vendorDetailData?.VendorRate,
        payment:
          valueSendFile === 'NewVendor' && payOriginalVendor === true && vendorDetailData?.vendorType !== '1'
            ? vendorDetailData?.VendorPayment
            : payVendor !== 'yes' || vendorDetailData?.vendorType === '1' || payOriginalVendor === false
              ? 0
              : vendorDetailData?.VendorPayment,
        SubmittedOn: formatDateWithMilliseconds(),
      };
      dispatch(ProofreaderRoleEditorSubmitRequest(params));
      closeModal();
    }
  };
  const formatDueDate = (dateString) => {
    const options = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    };
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', options).replace(',', ' at');
  };

  useEffect(() => {
    if (hour?.length === 0) {
      setHour(null);
    }
  }, [hour]);

  return (
    <Modal
      show={submitShow}
      size="lg"
      onHide={closeModal}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      dialogClassName="custom-modal"
    >
      <div>
        <div className="preview-dropdown-header py-3">
          <span className="fnt-20 fw-medium">
            {page === 'NewVendor' ? (valueSendFile === 'NewVendor' ? 'New Vendor' : 'Original Vendor') : page}
          </span>
          <HighlightOffRoundedIcon
            onClick={closeModal}
            className="cursor-pointer opacity-50"
            style={{ height: '28px', width: '28px' }}
          />
        </div>
        <div className="preview-dropdown-body">
          {page === 'Vendor Rating' && (
            <div className="row">
              <div className="col-9">
                <span className="fnt-17 fw-medium d-flex align-items-center">
                  Vendor Name :{' '}
                  <Avatar
                    alt="image"
                    src={
                      vendorDetailData?.ProfilePicture
                        ? `${VENDOR_IMAGE_URL}/${vendorDetailData?.ProfilePicture}`
                        : userInfo?.ProfilePicture
                          ? `${IMAGE_URL}/${userInfo?.ProfilePicture}`
                          : null
                    }
                    className="submit-profile-avatar mx-3"
                  />{' '}
                  <span className="fnt-16 fw-medium">
                    {vendorDetailData?.Name !== null
                      ? vendorDetailData?.Name
                      : capitalizeFirstLetter(
                          ((userInfo?.FirstName !== null && userInfo?.FileName !== 'null') === false
                            ? ''
                            : userInfo?.FirstName) +
                            ' ' +
                            ((userInfo?.LastName !== null && userInfo?.LastName !== 'null') === false
                              ? ''
                              : userInfo?.LastName),
                        )}
                  </span>
                </span>
              </div>
              <div className="col-3 text-end">
                <span>
                  <StarBorderRoundedIcon style={{ fontSize: '38px', color: '#fad85d' }} />{' '}
                  {vendorDetailData?.AverageRating || 0} / 5
                </span>
              </div>
              <div className="col-12 pt-4 d-flex justify-content-between">
                <span
                  className="fnt-14"
                  style={{
                    border: '1px solid gray',
                    padding: '6px 10px',
                    backgroundColor: '#efefef',
                    borderRadius: '4px',
                  }}
                >
                  Submission Ratio : {vendorDetailData?.OnTimeSubmission || 0}%
                </span>
                {vendorDetailData?.LevelName && (
                  <span
                    className="fnt-14"
                    style={{
                      border: '1px solid gray',
                      padding: '6px 10px',
                      backgroundColor: '#efefef',
                      borderRadius: '4px',
                    }}
                  >
                    {vendorDetailData?.LevelName}
                  </span>
                )}
                <span
                  className="fnt-14"
                  style={{
                    border: '1px solid gray',
                    padding: '6px 10px',
                    backgroundColor: '#efefef',
                    borderRadius: '4px',
                  }}
                >
                  Commitment Ratio : {vendorDetailData?.CommitmentRatio || 0}%
                </span>
              </div>
              <div className="col-12 pt-4">
                <span className="fnt-17 fw-medium d-flex align-items-center">
                  Rate Transcript :{' '}
                  <Rating
                    name="simple-controlled"
                    value={valueRating}
                    onChange={(event, newValue) => {
                      setBlockVendor('');
                      setValueRating(newValue === null ? 0 : newValue);
                    }}
                    style={{ fontSize: '34px' }}
                  />
                </span>
                {nextVendorRatingClick && valueRating === 0 && (
                  <div style={{ color: 'red' }}>{RATE_TRANSCRIPT_REQURIED}</div>
                )}
              </div>
              <div className="col-12 pt-4">
                <span className="fnt-17 fw-medium d-flex align-items-center">Rating Explanation : </span>
              </div>
              <div className="col-12 pt-2">
                <InputTextarea
                  value={rateExplanantionValue}
                  onChange={(e) => {
                    const trimmedValue = e.target.value.trim();
                    if (trimmedValue.length <= 255) {
                      setRateExplanantionValue(trimmedValue);
                    }
                  }}
                  rows={5}
                  style={{ width: '100%' }}
                />
                {nextVendorRatingClick && rateExplanantionValue === '' && (
                  <div style={{ color: 'red' }}>{RATING_EXPLANATION_REQURIED}</div>
                )}
              </div>
              {[1, 2, 3].includes(valueRating) && (
                <>
                  <div className="col-12 pt-4">
                    <span className="fnt-17 fw-medium d-flex align-items-center">
                      Do you want to block this Vendor?
                    </span>
                  </div>
                  <div className="col-12 pt-3">
                    <div className="d-flex gap-3">
                      <div className="flex align-items-center">
                        <RadioButton
                          inputId="ingredient1"
                          value="yes"
                          onChange={(e) => {
                            setBlockVendor(e.value);
                            setReworkNote('');
                            setPage('Vendor Rating');
                            setValueRework('');
                            setValueSendFile('');
                            setPayVendor('');
                            setSelectedVendor(null);
                            setPayOriginalVendor(false);
                            setHour(null);
                          }}
                          checked={blockVendor === 'yes'}
                        />
                        <label htmlFor="ingredient1" className="ms-2">
                          Yes
                        </label>
                      </div>
                      <div className="flex align-items-center">
                        <RadioButton
                          inputId="ingredient2"
                          value="no"
                          onChange={(e) => {
                            setBlockVendor(e.value);
                            setReworkNote('');
                            setPage('Vendor Rating');
                            setValueRework('');
                            setValueSendFile('');
                            setPayVendor('');
                            setSelectedVendor(null);
                            setPayOriginalVendor(false);
                            setHour(null);
                          }}
                          checked={blockVendor === 'no'}
                        />
                        <label htmlFor="ingredient2" className="ms-2">
                          No
                        </label>
                      </div>
                    </div>
                    {nextVendorRatingClick && blockVendor === '' && (
                      <div style={{ color: 'red', marginTop: '6px' }}>Select Yes or No for blocking the Vendor.</div>
                    )}
                  </div>
                </>
              )}
              <div className="col-12 text-center pt-5 pb-4">
                <Button
                  onClick={() => {
                    if (
                      rateExplanantionValue === '' ||
                      valueRating === 0 ||
                      ([1, 2, 3].includes(valueRating)
                        ? !(blockVendor === 'yes' || blockVendor === 'no')
                        : blockVendor !== '')
                    ) {
                      setPage('Vendor Rating');
                      setNextVendorRatingClick(true);
                      setNextPayClickVendor(false);
                      setNextReworkClick(false);
                    } else {
                      setPage('Rework');
                      setNextVendorRatingClick(false);
                      setNextReworkClick(false);
                      setNextPayClickVendor(false);
                    }
                  }}
                >
                  Next
                </Button>
              </div>
            </div>
          )}
          {page === 'Rework' && (
            <div className="row">
              <div className="col-12 pt-4">
                <span className="fnt-17 fw-medium d-flex align-items-center">
                  Do you want to send this file for Rework?
                </span>
              </div>
              <div className="col-12 pt-3">
                <div className="d-flex gap-3">
                  <div className="flex align-items-center">
                    <RadioButton
                      inputId="ingredient1"
                      value="yes"
                      onChange={(e) => {
                        setValueRework(e.value);
                        setReworkNote('');
                        setValueSendFile(
                          blockVendor === 'yes' || vendorDetailData?.BlockforWork === 1
                            ? 'NewVendor'
                            : 'OriginalVendor',
                        );
                        setPayVendor('');
                        setSelectedVendor(null);
                        setPayOriginalVendor(false);
                        setNextReworkClick(false);
                        setHour(null);
                      }}
                      checked={valueRework === 'yes'}
                    />
                    <label htmlFor="ingredient1" className="ms-2">
                      Yes
                    </label>
                  </div>
                  <div className="flex align-items-center">
                    <RadioButton
                      inputId="ingredient2"
                      value="no"
                      onChange={(e) => {
                        setValueRework(e.value);
                        setValueSendFile('');
                        setReworkNote('');
                        setPayVendor('');
                        setSelectedVendor(null);
                        setPayOriginalVendor(false);
                        setNextReworkClick(false);
                        setHour(null);
                      }}
                      checked={valueRework === 'no'}
                    />
                    <label htmlFor="ingredient2" className="ms-2">
                      No
                    </label>
                  </div>
                </div>
                {nextReworkClick && valueRework === '' && (
                  <div style={{ color: 'red', marginTop: '6px' }}>
                    Select Yes or No for sending the file for Rework.
                  </div>
                )}
              </div>
              {valueRework === 'yes' && (
                <div className="row">
                  {valueRework === 'yes' && (
                    <>
                      <div className="col-12 pt-4">
                        <span className="fnt-17 fw-medium d-flex align-items-center">Send this file to</span>
                      </div>
                      <div className="col-12 pt-3">
                        <div className="d-flex gap-3">
                          <div className="flex align-items-center">
                            <RadioButton
                              inputId="ingredient3"
                              value="OriginalVendor"
                              onChange={(e) => {
                                setValueSendFile(e.value);
                                setReworkNote('');
                                setPayVendor('');
                                setSelectedVendor(null);
                                setPayOriginalVendor(false);
                              }}
                              checked={valueSendFile === 'OriginalVendor'}
                              disabled={blockVendor === 'yes' || vendorDetailData?.BlockforWork === 1}
                            />
                            <label htmlFor="ingredient1" className="ms-2">
                              Original Vendor
                            </label>
                          </div>
                          <div className="flex align-items-center">
                            <RadioButton
                              inputId="ingredient4"
                              value="NewVendor"
                              onChange={(e) => {
                                setValueSendFile(e.value);
                                setReworkNote('');
                                setPayVendor('');
                                setSelectedVendor(null);
                                setPayOriginalVendor(false);
                              }}
                              checked={valueSendFile === 'NewVendor'}
                            />
                            <label htmlFor="ingredient2" className="ms-2">
                              New Vendor
                            </label>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {valueSendFile === 'NewVendor' && (
                    <>
                      <div className="col-5 pt-4">
                        <VendorSelectWithSearch
                          selectedVendor={selectedVendor}
                          setSelectedVendor={setSelectedVendor}
                          setSelectedNewVendor={setSelectedNewVendor}
                        />
                      </div>
                      <div className="col-2 pt-4"></div>
                      {vendorDetailData?.vendorType !== '1' && blockVendor !== 'yes' && (
                        <div className="col-5 pt-4">
                          <Checkbox
                            inputId="ingredient12"
                            onChange={(e) => setPayOriginalVendor(e.checked)}
                            checked={payOriginalVendor}
                          />
                          <label htmlFor="ingredient12" className="ms-2">
                            Pay Original Vendor
                          </label>
                        </div>
                      )}
                    </>
                  )}
                  <div className="col-12 pt-4">
                    <span className="fnt-17 fw-medium d-flex align-items-center">Rework Notes : </span>
                  </div>
                  <div className="col-12 pt-2">
                    <InputTextarea
                      value={reworkNote}
                      onChange={(e) => {
                        const trimmedValue = e.target.value.trim();
                        if (trimmedValue.length <= 255) {
                          setReworkNote(trimmedValue);
                        }
                      }}
                      placeholder="Write your rework instructions to the vendor"
                      rows={5}
                      style={{ width: '100%' }}
                    />
                    {nextReworkClick && reworkNote === '' && (
                      <div style={{ color: 'red' }}>{REWORK_NOTES_REQURIED}</div>
                    )}
                  </div>
                  {nextReworkClick && (hour === null || hour?.length === 0 || hour === 0 || hour === '') && (
                    <div className="col-12 pt-4" style={{ color: 'red' }}>
                      {editorDetailsData?.DueDate ? (
                        <>Client Due Date is {formatDueDate(editorDetailsData.DueDate)}</>
                      ) : (
                        <>Client Due Date is not set</>
                      )}
                    </div>
                  )}
                  <div className="col-12 pt-2">
                    <span className="fnt-17 fw-medium d-flex align-items-center">Rework Hour : </span>
                  </div>
                  <div className="col-5 pt-2">
                    <input
                      type="number" // Using number to fully control input behavior
                      value={hour}
                      onChange={(e) => {
                        let value = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters

                        if (value.length > 2) {
                          value = value.slice(0, 2); // Restrict to max 2 digits
                        }

                        if (value.length === 1 && value[0] === '0') {
                          value = ''; // Prevent leading zero
                        }

                        if ((parseInt(value) >= 1 && parseInt(value) <= 99) || value === '') {
                          setHour(value);
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                          e.preventDefault();
                        }
                      }}
                      style={{
                        width: '100%',
                        height: '40px',
                        padding: '0 10px',
                      }}
                      autoComplete="off"
                    />
                  </div>
                </div>
              )}
              <div className="col-12 text-center pt-5 pb-4">
                <Button
                  onClick={() => {
                    setNextVendorRatingClick(false);
                    setNextReworkClick(false);
                    setPage('Vendor Rating');
                  }}
                  className="me-2"
                >
                  Back
                </Button>
                <Button
                  onClick={() => {
                    if (
                      valueRework === 'yes'
                        ? !(
                            valueSendFile !== '' &&
                            reworkNote !== '' &&
                            hour !== null &&
                            (valueSendFile === 'NewVendor' ? selectedVendor !== null : selectedVendor == null)
                          )
                        : valueRework === ''
                    ) {
                      setNextReworkClick(true);
                      setNextVendorRatingClick(false);
                    } else {
                      if (vendorDetailData?.vendorType === '1') {
                        setPage('Summary');
                        setNextVendorRatingClick(false);
                        setNextReworkClick(false);
                        setNextPayClickVendor(false);
                      } else {
                        setPage(valueRework === 'yes' ? 'Summary' : 'Payment');
                        setNextVendorRatingClick(false);
                        setNextReworkClick(false);
                        setNextPayClickVendor(false);
                      }
                    }
                  }}
                >
                  Next
                </Button>
              </div>
            </div>
          )}
          {page === 'Payment' && (
            <div className="row">
              {valueRework === 'no' && (
                <>
                  <div className="col-12 pt-4">
                    <span className="fnt-17 fw-medium d-flex align-items-center">Do you want to pay the Vendor?</span>
                  </div>
                  <div className="col-12 pt-3">
                    <div className="d-flex gap-3">
                      <div className="flex align-items-center">
                        <RadioButton
                          inputId="ingredient3"
                          value="yes"
                          onChange={(e) => setPayVendor(e.value)}
                          checked={payVendor === 'yes'}
                        />
                        <label htmlFor="ingredient1" className="ms-2">
                          Yes
                        </label>
                      </div>
                      <div className="flex align-items-center">
                        <RadioButton
                          inputId="ingredient4"
                          value="no"
                          onChange={(e) => setPayVendor(e.value)}
                          checked={payVendor === 'no'}
                        />
                        <label htmlFor="ingredient2" className="ms-2">
                          No
                        </label>
                      </div>
                    </div>
                    {nextPayVendorClick && payVendor === '' && (
                      <div style={{ color: 'red', marginTop: '6px' }}>Select Yes or No for paying the Vendor.</div>
                    )}
                  </div>
                  {payVendor === 'yes' && (
                    <>
                      <div className="col-6 pt-4">
                        <span className="fnt-17 fw-medium me-3">Payment Details :</span>
                      </div>
                      <div className="col-6 pt-4 text-end">
                        <span
                          style={{
                            background: '#efe3e3',
                            padding: '8px 12px',
                            borderRadius: '4px',
                          }}
                        >
                          <span className="fnt-16 fw-medium me-3">Vendor Rate :</span>$
                          {vendorDetailData?.VendorRate || 0} /min
                        </span>
                      </div>
                      <div className="col-6 pt-4 d-flex d-flex align-items-center">
                        <span className="fnt-17 fw-medium me-3">File Length :</span>
                        {vendorDetailData?.Duration}
                      </div>
                      <div className="col-6 pt-4 d-flex d-flex align-items-center">
                        <span className="fnt-17 fw-medium me-3">Vendor Name :</span>
                        {vendorDetailData?.Name !== null
                          ? vendorDetailData?.Name
                          : capitalizeFirstLetter(
                              ((userInfo?.FirstName !== null && userInfo?.FileName !== 'null') === false
                                ? ''
                                : userInfo?.FirstName) +
                                ' ' +
                                ((userInfo?.LastName !== null && userInfo?.LastName !== 'null') === false
                                  ? ''
                                  : userInfo?.LastName),
                            )}
                      </div>
                      <div className="col-6 pt-4 d-flex d-flex align-items-center">
                        <span className="fnt-17 fw-medium me-3">Vendor Payment :</span>$
                        {vendorDetailData?.VendorPayment || 0}
                      </div>
                      <div className="col-6 pt-4 d-flex d-flex align-items-center">
                        <span className="fnt-17 fw-medium me-3">File Name :</span>
                        <CustomTooltips title={editorDetailsData?.UserFileName} placement="top">
                          {truncateString(editorDetailsData?.UserFileName, 18)}
                        </CustomTooltips>
                      </div>
                    </>
                  )}
                  <div className="col-12 text-center pt-5 pb-4">
                    <Button
                      onClick={() => {
                        setNextVendorRatingClick(false);
                        setNextPayClickVendor(false);
                        setPage('Vendor Rating');
                      }}
                      className="me-2"
                    >
                      Back
                    </Button>
                    <Button
                      onClick={() => {
                        if (payVendor === '') {
                          setNextPayClickVendor(true);
                          setNextVendorRatingClick(false);
                          setNextReworkClick(false);
                        } else {
                          setPage('Summary');
                          setNextVendorRatingClick(false);
                          setNextReworkClick(false);
                          setNextPayClickVendor(false);
                        }
                      }}
                    >
                      Next
                    </Button>
                  </div>
                </>
              )}
            </div>
          )}
          {page === 'Summary' && (
            <div className="row">
              <div className="col-9">
                <span className="fnt-17 fw-medium d-flex align-items-center">
                  Vendor Name :{' '}
                  <Avatar
                    alt="image"
                    src={
                      vendorDetailData?.ProfilePicture
                        ? `${VENDOR_IMAGE_URL}/${vendorDetailData?.ProfilePicture}`
                        : userInfo?.ProfilePicture
                          ? `${IMAGE_URL}/${userInfo?.ProfilePicture}`
                          : null
                    }
                    className="submit-profile-avatar mx-3"
                  />{' '}
                  <span className="fnt-16 fw-medium">{vendorDetailData?.Name}</span>
                </span>
              </div>
              <div className="col-3 text-end">
                <span>
                  <StarBorderRoundedIcon style={{ fontSize: '38px', color: '#fad85d' }} /> {valueRating || 0} / 5
                </span>
              </div>
              <div className="col-12 pt-4">
                <span className="fnt-17 fw-medium d-flex align-items-center">Rating Feedback :</span>
              </div>
              <div className="col-12 pt-2 text-break">{rateExplanantionValue}</div>
              <div className="col-12 pt-4 bb-1"></div>
              <div className="col-6 pt-4 d-flex d-flex align-items-center">
                <span className="fnt-17 fw-medium me-3">Rework :</span>
                {valueRework === 'yes' ? 'Yes' : 'No'}
              </div>
              {valueRework === 'yes' && (
                <>
                  <div className="col-6 pt-4 d-flex d-flex align-items-center">
                    <span className="fnt-17 fw-medium me-3">Rework to :</span>
                    {selectedVendor !== null ? (
                      <>
                        <div className="position-relative">
                          <Avatar
                            alt="image"
                            src={
                              selectedNewVendor?.ProfilePicture !== null && selectedNewVendor?.ProfilePicture
                                ? `${VENDOR_IMAGE_URL}/${selectedNewVendor?.ProfilePicture}`
                                : null
                            }
                            className="submit-profile-avatar mx-3"
                          />
                          <span
                            style={{
                              position: 'absolute',
                              bottom: 0,
                              right: '14px',
                              width: '10px',
                              height: '10px',
                              borderRadius: '50%',
                              backgroundColor: selectedNewVendor?.isClaimed === 1 ? 'red' : 'green',
                              border: '2px solid white',
                            }}
                          />
                        </div>{' '}
                        {selectedNewVendor?.Name}{' '}
                        {selectedNewVendor?.IsInHouse === 1 && (
                          <HomeOutlinedIcon
                            style={{
                              color: '#190041',
                              fontSize: '30px',
                              marginLeft: '6px',
                            }}
                          />
                        )}
                      </>
                    ) : (
                      <>
                        <div className="position-relative">
                          <Avatar
                            alt="image"
                            src={
                              vendorDetailData?.ProfilePicture
                                ? `${VENDOR_IMAGE_URL}/${vendorDetailData?.ProfilePicture}`
                                : userInfo?.ProfilePicture
                                  ? `${IMAGE_URL}/${userInfo?.ProfilePicture}`
                                  : null
                            }
                            className="submit-profile-avatar mx-3"
                          />
                        </div>{' '}
                        {vendorDetailData?.Name !== null
                          ? vendorDetailData?.Name
                          : capitalizeFirstLetter(
                              ((userInfo?.FirstName !== null && userInfo?.FileName !== 'null') === false
                                ? ''
                                : userInfo?.FirstName) +
                                ' ' +
                                ((userInfo?.LastName !== null && userInfo?.LastName !== 'null') === false
                                  ? ''
                                  : userInfo?.LastName),
                            )}{' '}
                      </>
                    )}
                  </div>
                  <div className="col-6 pt-4 d-flex d-flex align-items-center">
                    <span className="fnt-17 fw-medium me-3">Rework hour :</span>
                    {hour}
                  </div>
                  <div className="col-6 pt-4 d-flex d-flex align-items-center">
                    <span className="fnt-17 fw-medium me-3">Client Due Date :</span>
                    {moment(editorDetailsData?.DueDate).format('MM/DD/YY')}
                  </div>
                  <div className="col-12 pt-4">
                    <span className="fnt-17 fw-medium d-flex align-items-center">Rework Notes :</span>
                  </div>
                  <div className="col-12 pt-2 text-break">{reworkNote}</div>
                </>
              )}
              {vendorDetailData?.vendorType !== '1' && (
                <>
                  {valueSendFile === 'NewVendor' &&
                    payOriginalVendor &&
                    valueRework === 'yes' &&
                    blockVendor !== 'yes' && (
                      <>
                        <div className="col-12 pt-4 bb-1"></div>
                        <div className="col-12 pt-4">
                          <span className="fnt-17 fw-medium me-3">Payment Details :</span>
                        </div>
                        <div className="col-6 pt-4 d-flex d-flex align-items-center">
                          <span className="fnt-17 fw-medium me-3">Vendor Rate :</span>$
                          {vendorDetailData?.VendorRate || 0} /min
                        </div>
                        <div className="col-6 pt-4 d-flex d-flex align-items-center">
                          <span className="fnt-17 fw-medium me-3">Vendor Payment :</span>$
                          {vendorDetailData?.VendorPayment || 0}
                        </div>
                      </>
                    )}
                  {valueSendFile === 'NewVendor' &&
                    payOriginalVendor === false &&
                    valueRework === 'yes' &&
                    blockVendor !== 'yes' && (
                      <>
                        <div className="col-12 pt-4 bb-1"></div>
                        <div className="col-12 pt-4">
                          <span className="fnt-17 fw-medium me-3">Payment Details :</span>
                        </div>
                        <div className="col-12 pt-4 d-flex d-flex align-items-center">
                          <span className="fnt-17 fw-medium me-3">Note :</span>
                          {vendorDetailData?.vendorType === '1'
                            ? 'This is InHouse Vendor.'
                            : 'Vendor Payment is Rejected for this File.'}
                        </div>
                      </>
                    )}
                  {payVendor === 'yes' && valueRework === 'no' && (
                    <>
                      <div className="col-12 pt-4 bb-1"></div>
                      <div className="col-12 pt-4">
                        <span className="fnt-17 fw-medium me-3">Payment Details :</span>
                      </div>
                      <div className="col-6 pt-4 d-flex d-flex align-items-center">
                        <span className="fnt-17 fw-medium me-3">Vendor Rate :</span>${vendorDetailData?.VendorRate || 0}{' '}
                        /min
                      </div>
                      <div className="col-6 pt-4 d-flex d-flex align-items-center">
                        <span className="fnt-17 fw-medium me-3">Vendor Payment :</span>$
                        {vendorDetailData?.VendorPayment || 0}
                      </div>
                    </>
                  )}
                  {payVendor === 'no' && valueRework === 'no' && (
                    <>
                      <div className="col-12 pt-4 bb-1"></div>
                      <div className="col-12 pt-4">
                        <span className="fnt-17 fw-medium me-3">Payment Details :</span>
                      </div>
                      <div className="col-12 pt-4 d-flex d-flex align-items-center">
                        <span className="fnt-17 fw-medium me-3">Note :</span>
                        {vendorDetailData?.vendorType === '1'
                          ? 'This is InHouse Vendor.'
                          : 'Vendor Payment is Rejected for this File.'}
                      </div>
                    </>
                  )}
                  {blockVendor === 'yes' && valueRework === 'yes' && (
                    <>
                      <div className="col-12 pt-4 bb-1"></div>
                      <div className="col-12 pt-4">
                        <span className="fnt-17 fw-medium me-3">Payment Details :</span>
                      </div>
                      <div className="col-12 pt-4 d-flex d-flex align-items-center">
                        <span className="fnt-17 fw-medium me-3">Note :</span>
                        {vendorDetailData?.vendorType === '1'
                          ? 'This is InHouse Vendor.'
                          : 'Vendor Payment is Rejected for this File.'}
                      </div>
                    </>
                  )}
                </>
              )}
              {vendorDetailData?.vendorType === '1' && (
                <>
                  <div className="col-12 pt-4 bb-1"></div>
                  <div className="col-12 pt-4">
                    <span className="fnt-17 fw-medium me-3">Payment Details :</span>
                  </div>
                  <div className="col-12 pt-4 d-flex d-flex align-items-center">
                    <span className="fnt-17 fw-medium me-3">Note :</span>
                    {vendorDetailData?.vendorType === '1'
                      ? 'This is InHouse Vendor.'
                      : 'Vendor Payment is Rejected for this File.'}
                  </div>
                </>
              )}
              <div className="col-12 text-center pt-5 pb-4">
                <Button
                  onClick={() => {
                    setNextVendorRatingClick(false);
                    setNextReworkClick(false);
                    setNextPayClickVendor(false);
                    setPage('Rework');
                  }}
                  className="me-2"
                >
                  Back
                </Button>
                <Button onClick={handleConfirm}>Confirm</Button>
              </div>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ProofreaderSubmitModal;
